import type { SignInfo } from '@shared/core-types';
import { getEnv } from '@luna/env';
import { getFeatureConfig } from '@luna/feature-config';

export const getCDMUrl = (): string => getEnv().contactsDataManagementUrl;
const getPrestoUrl = (): string => getEnv().prestoUrl;

const SIGNING_OPERATION_TYPE = 'CONTACT_DATA_MANAGEMENT';

export function getContactSigningUrl(signInfo: SignInfo, contactId?: string): string {
    const { operationAgnosticSigningEnabled } = getFeatureConfig(
        (config) => config.contactDataManagement,
    );

    if (operationAgnosticSigningEnabled) {
        return `${getPrestoUrl()}auth/operation/sign/${signInfo.signId}?operationType=${SIGNING_OPERATION_TYPE}`;
    }

    if (contactId) {
        return `${getCDMUrl()}/${contactId}/sign/${signInfo.signId}`;
    }

    return `${getCDMUrl()}/sign/${signInfo.signId}`;
}
